import * as React from 'react';
import URLParams from 'utils/url-params';

import { translate } from 'components/translate-hoc';
import { ITranslationProps } from 'types/translation';
import RedeemCodeForm from '../redeem-code/redeem-code.component';
import { getTrackingFlowSubType } from 'utils/analytics';
import { ConfigContext } from 'modules/context';

// service
import AnalyticsService from 'modules/analytics-provider/analytics-provider.service';

// constants
import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';
import {
    ICodeFirstLandingDispatchProps,
    ICodeFirstLandingStoreProps
} from './code-first-landing.container';
import {
    PLATFORM_URL_PARAMETER,
    CODE_URL_PARAMETER
} from '../redemption/redemption-platform-selection/redemption-platform-selection.constants';
import { TEXT_KEYS } from './code-first-landing.constants';
import { ERROR_TEXT_KEYS } from '../redemption/redemption.constants';
import {
    INITIAL_LANDING_DATA,
    ON_SUBMIT_CODE_DATA
} from './code-first-landing.constants';

import './landing.styles.less';

export class CodeFirstLanding extends React.Component<ICodeFirstLandingProps, ICodeFirstLandingState> {
    public state: ICodeFirstLandingState = {
        code: '',
        isCodeValid: false,
        showError: false
    };

    public componentDidMount() {
        const codeFromURL = URLParams().get(CODE_URL_PARAMETER);
        if (codeFromURL) {
            this.setState({ code: codeFromURL });
        }

        const platformUrlParameter = URLParams().get(PLATFORM_URL_PARAMETER);
        const platformFromURL = platformUrlParameter && PLATFORM_TYPES[platformUrlParameter];
        if (platformFromURL) {
            this.props.savePlatformType(platformFromURL as PLATFORM_TYPES);
        }

        AnalyticsService.sendFlowEvent({
            ...INITIAL_LANDING_DATA,
            flowSubType: getTrackingFlowSubType(this.props.widgetName)
        });
    }

    public updateCode = ({ code, isValid }: {
        code: string,
        isValid: boolean
    }) => this.setState({ showError: false, code, isCodeValid: isValid });

    public handleSubmit = () => {
        this.setState({ showError: true });

        if (this.state.isCodeValid) {
            AnalyticsService.sendFlowEvent({
                ...ON_SUBMIT_CODE_DATA,
                flowSubType: getTrackingFlowSubType(this.props.widgetName)
            });
            this.props.saveRedeemCode(this.state.code);
            this.props.goToLoginPage();
        }
    };

    public renderError() {
        const { dangerouslyTranslateWithHTML: translateKey } = this.props;
        const errorText = translateKey(ERROR_TEXT_KEYS.ERROR_INVALID_CODE);

        return !this.state.isCodeValid && this.state.showError
            ? <div className="sitegen-redemption__error">{errorText}</div>
            : null;
    }

    public render(): JSX.Element {
        const { dangerouslyTranslateWithHTML: translateKey } = this.props;
        const { getModeClass } = this.context;
        const title = translateKey(TEXT_KEYS.LANDING_TITLE);
        const description = translateKey(TEXT_KEYS.LANDING_DESCRIPTION);

        return (
            <div className={getModeClass('sitegen-landing')}>
                <div className={getModeClass('sitegen-landing__title')}>{title}</div>
                <div className={getModeClass('sitegen-landing__description')}>{description}</div>

                <RedeemCodeForm
                    fetching={this.props.fetching}
                    code={this.state.code}
                    codeFormat={this.props.codeFormat}
                    updateCode={this.updateCode}
                    submitCode={this.handleSubmit}
                />
                {this.renderError()}
            </div>
        );
    }
}

CodeFirstLanding.contextType = ConfigContext;

interface ICodeFirstLandingState {
    readonly code: string;
    readonly isCodeValid: boolean;
    readonly showError: boolean;
}

export type ICodeFirstLandingProps = ICodeFirstLandingStoreProps & ICodeFirstLandingDispatchProps & ITranslationProps;
export default translate()(CodeFirstLanding);
